import { render, staticRenderFns } from "./Matriz1.vue?vue&type=template&id=c1b72092&"
import script from "./Matriz1.vue?vue&type=script&lang=js&"
export * from "./Matriz1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports